<template>
  <div v-if="skeleton" class="article-card">
    <div class="mb-1">
      <div class="skeleton" style="padding-top: 111.111%"></div>
    </div>
    <div>
      <p class="text-label skeleton skeleton--bar mb-0-4" style="width: 40%">
        &nbsp;
      </p>
      <p
        class="article-card__title skeleton skeleton--bar w-600 mb-0-4"
        style="width: 80%"
      >
        &nbsp;
      </p>

      <div class="text-small">
        <p class="skeleton skeleton--bar mb-0-2" style="width: 85%">&nbsp;</p>
        <p class="skeleton skeleton--bar mb-0-2" style="width: 80%">&nbsp;</p>
        <p class="skeleton skeleton--bar mb-0-2" style="width: 40%">&nbsp;</p>
      </div>
    </div>
  </div>
  <nuxt-link v-else :to="articleLink" :href="articleLink" class="article-card">
    <div class="article-card__image mb-0-8 mb-md-1">
      <lazy-image
        v-if="image"
        :image="image"
        provider="sanity"
        :widths="[320, 414, 640, 769]"
      />
      <img
        v-else
        class="article-card__image"
        src="https://images.prismic.io/asphalte/87462063-cc42-44de-8048-669995a923eb_placeholder.jpg?auto=compress,format&rect=0,0,1400,2000&w=700&h=1000"
        alt="#"
      />

      <p class="article-card__read text-label text-uppercase">
        {{ $t('article.next') }}
      </p>
    </div>
    <div class="article-card__content">
      <p v-if="article.published_at" class="text-extra-small mb-0-2">
        {{ $d(new Date(article.published_at), 'month-day') }}
      </p>
      <p class="article-card__title w-600 mb-0-4">
        <span v-if="article.title">
          {{ article.title }}
        </span>
      </p>

      <p v-if="hasHook" class="d-none d-md-block text-small">
        {{ hook }}
      </p>
    </div>
  </nuxt-link>
</template>

<script>
import LazyImage from '@/components/Image/LazyImage'
import { getSanityBunnyImageLink } from '@/utils/image'

export default {
  name: 'ArticleCard',
  components: {
    LazyImage,
  },
  props: {
    article: { type: Object, required: true },
    type: { type: String, default: 'article' },
    skeleton: { type: Boolean, default: false },
  },
  computed: {
    image() {
      if (this.article.image_list) {
        return {
          url: getSanityBunnyImageLink(this.article.image_list, {
            width: 396,
            height: 440,
          }),
          dimensions: {
            width: 396,
            height: 440,
          },
        }
      }

      if (this.article.with_image_header && this.article.image_header.image) {
        return {
          url: getSanityBunnyImageLink(this.article.image_header.image, {
            width: 396,
            height: 440,
          }),
          dimensions: {
            width: 396,
            height: 440,
          },
        }
      }

      return null
    },
    articleLink() {
      return this.$contextSanityPath({
        _type: this.type,
        uid: this.article.uid,
        context: this.$route.params.context,
      })
    },
    hasHook() {
      return this.article.hook && this.article.hook.length > 0
    },
    hook() {
      if (this.hasHook) {
        return this.article.hook
          .map((item) => item.children?.map((child) => child.text).join(' '))
          .join(' ')
      }

      return ''
    },
  },
}
</script>

<style lang="scss">
.article-card {
  cursor: pointer;
  display: block;

  &__image {
    position: relative;
    background: black;

    .lazy-image-container {
      transition: all 0.3s;
    }
  }

  &__read {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    color: var(--tertiary-color);
    text-transform: uppercase;
    opacity: 0;
    transition: all 0.3s;
  }

  @include on-hover-and-focus {
    .article-card__title {
      text-decoration: underline;
    }

    .article-card__read {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }

    .article-card__image {
      .lazy-image-container {
        opacity: 0.6;
      }
    }
  }
}
</style>
